import { render } from "./Cliente_Orden.vue?vue&type=template&id=37df6456"
import script from "./Cliente_Orden.vue?vue&type=script&lang=js"
export * from "./Cliente_Orden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__